export const screenCopyEn = {
  app: {
    checkingSignInStatus: "Checking sign-in status…",
  },
  assignmentRecords: {
    backToCategories: "← Back to categories",
    closeNewTask: "Close new task",
    newTaskRecord: "＋ New task record",
    recordCategories: "Record categories",
    enterATaskNameAndAValid: "Enter a task name and a valid maximum score.",
    theMaximumCannotBeLowerThanSaved:
      "The maximum cannot be lower than saved student scores. Update those scores first.",
    couldNotSaveTheTaskTryAgain: "Could not save the task. Try again.",
    eGWorksheetUnitTest: "e.g. Worksheet 3 / Unit 1 test",
    dueTestDate: "Due / test date",
    maximumScoreOptional: "Maximum score (optional)",
    eG: "e.g. 100",
    taskNotes: "Task notes",
    searchTasks: "Search tasks",
    searchTasksDatesOrNotes: "Search tasks, dates or notes",
    showing: "Showing",
    records: " records",
    taskDetails: "Task details",
    open: "Open {{title}}",
    outOf: " · Out of {{maxScore}}",
    no: "No. {{number}} {{name}}",
    noRecordsMatchYourSearch: "No records match your search.",
    youHaveUnsavedChangesReturnToThe: "You have unsaved changes. Return to the directory and discard them?",
    saveFailedYourChangesRemainOnScreen: "Save failed. Your changes remain on screen. Try again.",
    backToRecordDirectory: "← Back to record directory",
    notSavedYet: "Not saved yet",
    score: "Score",
    noActiveStudentsInThisClassImport: "No active students in this class. Import a roster in Administration first.",
  },
  betaFeedback: {
    submissionFailedYourFeedbackIsRetained: "Submission failed. Your feedback is retained.",
    trialFeedback: "Trial feedback",
    closeFeedback: "Close feedback",
    feedbackIsOptionalAndSentWithYour:
      "Feedback is optional and sent with your signed-in account. Only the category, content and optional email are sent, without class data, student data or activity logs. Do not include student names or other personal data.",
    feedbackReceivedThankYouForHelpingImprove: "Feedback received. Thank you for helping improve the trial.",
    writeMoreFeedback: "Write more feedback",
    nothingIsSentUntilYouConfirm: "Nothing is sent until you confirm",
    feedbackToSubmit: "Feedback to submit",
    content: "Content",
    followUpEmail: "Follow-up email",
    noEmailProvided: "No email provided",
    backToEdit: "Back to edit",
    submitting: "Submitting…",
    confirmAndSubmitFeedback: "Confirm and submit feedback",
    checkTheFeedbackContent: "Check the feedback content.",
    feedbackCategory: "Feedback category",
    feedbackContent: "Feedback content",
    whichFeatureHasAProblemOrWhat: "Which feature has a problem, or what would you like improved?",
    characters: "/ 2000 characters",
    iWouldLikeToProvideAnEmail: "I would like to provide an email for follow-up",
    previewFeedback: "Preview feedback",
  },
  calendarImportDialog: {
    publicHoliday: "Public holiday",
    schoolHoliday: "School holiday",
    specialSchoolDay: "Special school day",
    specialDate: "Special date",
    examAssessment: "Exam / assessment",
    studentActivity: "Student activity",
    administrativeReminderDeadline: "Administrative reminder / deadline",
    classTest: "Class test",
    enterAValidStartDate: "Enter a valid start date",
    invalidEndDateFormat: "Invalid end date format",
    endDateIsBeforeStartDate: "End date is before start date",
    enterAnEventName: "Enter an event name",
    anEventWithTheSameDateAnd: "An event with the same date and name already exists",
    noCalendarEventsFoundToReview: "No calendar events found to review.",
    couldNotReadTheSchoolCalendarFile: "Could not read the school calendar file.",
    selectAtLeastOneValidSchoolCalendar: "Select at least one valid school calendar event.",
    itemsStillNeedCorrection: "{{length}} items still need correction.",
    couldNotImportSchoolCalendarEvents: "Could not import school calendar events.",
    importSchoolCalendar: "Import school calendar",
    schoolYearStartingYearOptional: "School year starting year (optional)",
    eG: "e.g. 2026",
    chooseCalendarFile: "Choose calendar file",
    excelXlsxCSVICSOrPDF: "Excel (.xlsx), CSV, ICS or PDF",
    analyseAgain: "Analyse again",
    chooseAnotherFile: "Choose another file",
    processingTheSchoolCalendarPleaseWait: "Processing the school calendar. Please wait…",
    pleaseNote: "Please note",
    recognised: "Recognised",
    items: " items",
    selected: " selected ·",
    availableToImport: " available to import",
    selectAllImportableItems: "Select all importable items",
    needReviewOrCorrection: " need review or correction",
    item: "Item",
    label: ":",
    schoolCalendarEventsToReview: "School calendar events to review",
    import: "Import",
    event: "Event",
    sourceAndStatus: "Source and status",
    importItem: "Import item {{value}}: {{title}}",
    start: "Start",
    end: "End",
    notesOptional: "Notes (optional)",
    highConfidence: "High confidence",
    quickReviewNeeded: "Quick review needed",
    correctionNeeded: "Correction needed",
    viewSourceText: "View source text",
  },
  legalAcceptanceGate: {
    couldNotRecordAcceptanceTryAgain: "Could not record acceptance. Try again.",
    setUpTheCollectionNoticeBeforeUsing: "Set up the collection notice before using real student data",
    theseDetailsAppearBeforeStudentsJoinQuizzes:
      "These details appear before students join quizzes, explaining who collects data and who handles access or correction requests.",
    theOperatorSLegalContactDetailsAre:
      "The operator's legal contact details are not configured. Terms cannot be accepted and real student data cannot be entered yet.",
    schoolDataUserName: "School / data user name",
    personOrTitleHandlingAccessAndCorrection: "Person or title handling access and correction requests",
    eGDataProtectionOfficer: "e.g. Data protection officer",
    contactEmail: "Contact email",
    contactAddress: "Contact address",
    iHaveReadAndAccept: "I have read and accept",
    and: "and",
    iConfirmSchoolAuthorisationToProcessAnd:
      "I confirm school authorisation to process and upload the relevant student data, and will provide the applicable collection statement to students or parents before uploading rosters.",
    recording: "Recording…",
    saveNoticeAndConfirm: "Save notice and confirm",
    schoolContactsAcceptanceDateAndTermsVersions:
      "School contacts, acceptance date and terms versions are stored in the account for quiz notices and compliance records.",
  },
  localDataPanel: {
    encryptedBackupDownloadedSaveItToYour:
      "Encrypted backup downloaded. Save it to your chosen cloud drive and keep the password separately.",
    backupFailed: "Backup failed.",
    restoringReplacesAllLocalClassroomDataIn:
      "Restoring replaces all local classroom data in this browser with the backup. Download a current backup first. Continue?",
    backupRestoredCheckThatYourClassesAnd: "Backup restored. Check that your classes and records are complete.",
    restoreFailedExistingDataIsUnchanged: "Restore failed. Existing data is unchanged.",
    localData: "Local data",
    dataInThisBrowser: "Data in this browser",
    available: "Available",
    checkingUnsupported: "Checking / unsupported",
    persistentStorage: "Persistent storage",
    granted: "Granted",
    notGranted: "Not granted",
    siteStorageUsed: "Site storage used",
    processing: "Processing…",
    readingDataAndCreatingAConsistentSnapshot: "Reading data and creating a consistent snapshot…",
    encryptingBackup: "Encrypting backup…",
    restoreFromEncryptedFile: "Restore from encrypted file",
    chooseBackupFile: "Choose backup file",
  },
  pwaUpdateNotice: {
    localDataIsStillBeingProcessedWait:
      "Local data is still being processed. Wait for saving to finish before updating.",
    saveClassroomRecordsFirstUpdatingReloadsThe:
      "Save classroom records first. Updating reloads the page and discards unsaved input. Have you saved and are you ready to update?",
    theUpdateIsNotReadyTryAgain: "The update is not ready. Try again later.",
    theNewVersionHasDownloadedInThe:
      "The new version has downloaded in the background. Save your work before updating. Saved local data is retained.",
    updating: "Updating…",
    updateAfterSaving: "Update after saving",
  },
  recordImportPanel: {
    couldNotAnalyseTheWorksheet: "Could not analyse the worksheet.",
    importedRowsInto: "Imported {{length}} '{{label}}' rows into {{name}}",
    couldNotCompleteImportIfSomeData:
      "Could not complete import: {{value}}. If some data was saved, reload and check. Existing records will be recognised.",
    chooseAClassFirst: "Choose a class first.",
    recordType: "Record type",
    headerRow: "Header row",
    row: "Row",
    label: ":",
    reviewColumns: "Review columns",
    doNotUse: "Do not use",
    untitledColumn: "Untitled (column {{value}})",
    readyToImport: "Ready to import",
    alreadyExists: "Already exists",
    conflict: "Conflict",
    needsCorrection: "Needs correction",
    selected: "Selected",
    import: "Import",
    record: "Record",
    checkResult: "Check result",
    importRow: "Import row {{rowNumber}}",
    importing: "Importing…",
    confirmImportOfRows: "Confirm import of {{length}} rows",
  },
  teacherConsole: {
    participationOverview: "Participation overview",
    recordEntry: "Record entry",
    questionBankAndQuizzes: "Question bank and quizzes",
    sharedTools: "Shared tools",
    administration: "Administration",
    leaveLocalTrial: "Leave local trial",
    leavePreview: "Leave preview",
    featureTourCompleteYouCanNowEdit: "Feature tour complete. You can now edit the fictional data freely.",
    demoFeatureTourDoesNotCover: "Demo feature tour does not cover:",
    localData: "Local data",
    preparingYourClassroom: "Preparing your classroom…",
    checkingPrivacyAndTermsAcceptance: "Checking privacy and terms acceptance…",
    sharedClassNotFoundSelectItAgain: "Shared class not found. Select it again.",
    matchingTaskNotFoundReopenTheRecord: "Matching task not found. Reopen the record directory.",
    localQuizzesAreNotAvailableYet: "Local quizzes are not available yet.",
    tools: "Tools",
    tabs: "{{recordGroupLabel}} tabs",
    skipToClassSelection: "Skip to class selection",
    startClassSetup: "Start class setup",
    whichClassAreYouTeachingToday: "Which class are you teaching today?",
    featureTour: "Feature tour",
    localPreviewOnly: "Local preview only",
    setupGuide: "Setup guide",
    gettingStartedGuide: "Getting started guide",
    firstTimeSetup: "First-time setup",
    readyToBegin: "Ready to begin",
    setUpClassesRostersAndSeatingFirst: "Set up classes, rosters and seating first",
    setupProgress: "Setup progress",
    settingUp: "Setting up",
    createClass: "Create class",
    addAnotherClass: "Add another class",
    completeTheDetailsBelow: "Complete the details below",
    students: " students",
    viewRoster: "View roster",
    viewSeats: "View seats",
    arrangeSeats: "Arrange seats",
    open: "Open",
    importSchoolWideCalendar: "Import school-wide calendar",
    chooseVisibleTools: "Choose visible tools",
    backToClassSelection: "Back to class selection",
    noHomeroomClassCreatedYet: "No homeroom class created yet.",
    noTeachingClassesCreatedYet: "No teaching classes created yet.",
    couldNotCreateTheClass: "Could not create the class.",
    newClassName: "New class name",
    eGAChinese: "e.g. 1A Chinese",
    classPurpose: "Class purpose",
    createNewData: "Create new data",
    useDataFrom: "Use data from '",
    label: "'",
    creating: "Creating…",
    addClass: "＋ Add class",
    createYourFirstClass: "Create your first class",
    goToClassRoster: "Go to class roster",
    toolVisibilitySettingsSaved: "Tool visibility settings saved",
    couldNotSaveSettings: "Could not save settings.",
    visible: " visible",
    showAll: "Show all",
    saving: "Saving…",
    saveSettings: "Save settings",
    show: "Show {{label}}",
    label_e6d84: "{{value1}} / {{value}}",
    otherClasses: "Other classes",
    schoolWide: "School-wide",
    viewCalendar: "{{value}}, {{scope}}, {{value2}}: {{title}}. View calendar",
    agendaRange: "Agenda range",
    nextTwoWeeks: "Next two weeks",
    fullYear: "Full year",
    eventsInTheNextTwoWeeks: "Events in the next two weeks",
    events: " events",
    nextTwoWeeksCalendar: "Next two weeks calendar",
    week: "Week",
    events_5f353: "{{value}}, {{length}} events",
    month: "Month",
    events_9cc64: " events",
    viewCalendar_89ab2: "{{value}}: {{title}}. View calendar",
    more: "More:",
    allTasksInTheNextTwoWeeks: "All tasks in the next two weeks",
    noTasksInTheNextTwoWeeks: "No tasks in the next two weeks",
    fullYearEvents: "Full-year events",
    schoolYearOverviewSeptemberToAugust: "School year overview · September to August",
    previousSchoolYear: "Previous school year",
    nextSchoolYear: "Next school year",
    noEvents: "No events",
    events_9916d: "{{label}} events",
    noEventsThisMonth: "No events this month.",
    classStatistics: "Class statistics",
    totalMissingMaterials: "Total missing books and notes",
    missingMaterialsToday: "Missing books and notes today",
    totalResponses: "Total responses",
    studentsWhoHaveAnswered: "Students who have answered",
    responsesToday: "Responses today",
    noSeatingChartYet: "No seating chart yet",
    openSeatingChart: "Open seating chart",
    teacherView: "Teacher view ·",
    rows: " rows ×",
    columns: " columns ·",
    aisles: " aisles",
    no: "No.",
    recordedTodayTotal: "Recorded today · {{missingMaterials}} total",
    total: "{{missingMaterials}} total",
    answers: " answers",
    randomSelectionAndGroupingTools: "Random selection and grouping tools",
    chooseTool: "Choose tool",
    pickStudents: "Pick students",
    quickGroups: "Quick groups",
    studentsNoRepeatsThisRound: " students · No repeats this round",
    createGroups: "Create groups",
    randomStudentPicker: "Random student picker",
    selecting: "Selecting…",
    selectedThisTime: "Selected this time",
    readyToPick: "Ready to pick",
    selectTheButtonToBegin: "Select the button to begin",
    currentRound: "Current round",
    remaining: "Remaining:",
    students_49127: " students",
    pickAStudent: "Pick a student",
    roundComplete: "Round complete",
    resetRoster: "Reset roster",
    startNextRound: "Start next round",
    quickBalancedGroups: "Quick balanced groups",
    group: "Group",
    chooseAMethodToCreateGroups: "Choose a method to create groups",
    noTaskDescription: "No task description",
    searchStudents: "Search students",
    enterNameOrClassNumber: "Enter name or class number",
    active: "Active",
    noMatchingStudents: "No matching students.",
    classOverview: "Class overview",
    studentRecordCategories: "Student record categories",
    attendanceRecords: "Attendance records",
    classRecordSummary: "Class record summary",
    recordedDays: "Recorded days",
    absences: "Absences",
    attendanceChecks: " attendance checks",
    lateArrivals: "Late arrivals",
    activeStudents: " active students",
    missingSubmissions: "Missing submissions",
    records: " records",
    studentsWithMoreRecords: "Students with more records",
    late: "Late",
    noStudentRecordsToSummariseYet: "No student records to summarise yet.",
    missingWorkBySubject: "Missing work by subject",
    missingSubmissions_305a6: "{{subject}}: {{count}} missing submissions",
    noMissingWorkRecordsYet: "No missing-work records yet.",
    recentRecords: "Recent records",
    openAttendance: "Open attendance",
    openMissingHomework: "Open missing homework",
    noAttendanceOrMissingWorkRecordsYet: "No attendance or missing-work records yet.",
    absentDates: "Absent dates",
    openAttendance_8f396: "Open attendance →",
    noAbsencesRecorded: "No absences recorded",
    missingSubmissions_28ccc: "Missing submissions",
    subjectsInvolved: "Subjects involved",
    latestMissingWork: "Latest missing work",
    missingTasks: "Missing tasks",
    openMissingHomework_476e3: "Open missing homework →",
    bySubject: "By subject",
    noMissingWorkRecordsForThisStudent: "No missing-work records for this student.",
    studentNotFound: "Student not found",
    noStudentRosterYet: "No student roster yet",
    classAttendance: "Class attendance",
    attendanceDate: "Attendance date",
    attendanceStatistics: "Attendance statistics",
    classTotal: "Class total",
    attendanceBySeat: "Attendance by seat",
    label_07242: ", {{genderLabel}}",
    unseated: "Unseated ·",
    enterAUniqueSubjectNameOfTo: "Enter a unique subject name of 1 to 40 characters.",
    addedSubject: "Added subject '{{name}}'",
    couldNotAddTheSubject: "Could not add the subject.",
    delete: "Delete '{{value}}{{value1}}'?",
    missingWorkRecordDeleted: "Missing-work record deleted",
    couldNotDeleteTheMissingWorkRecord: "Could not delete the missing-work record.",
    no_ed3bb: "No. {{number}} {{name}}: {{value}}",
    missing: "✓ Missing",
    submitted: "Submitted",
    selected: "Selected",
    students_74c77: " students",
    editMissingTask: "Edit missing task",
    newMissingTask: "New missing task",
    subject: "Subject",
    chooseSubject: "Choose subject",
    notApplicable: "Not applicable",
    customSubject: "Custom subject",
    enterAnotherSubject: "Enter another subject",
    addSubject: "Add subject",
    recordAnotherDate: "Record another date",
    backToToday: "Back to today",
    missingWorkType: "Missing-work type",
    taskDescription: "Task description",
    eGWorkbookPpParentReplySlip: "e.g. Workbook pp.12–13 / Parent reply slip",
    selectStudentsWithMissingWork: "Select students with missing work",
    clearAll: "Clear all",
    studentSelectionMethod: "Student selection method",
    unseated_ae6ad: "Unseated",
    missingWorkForThisDate: "Missing work for this date",
    addAnotherTask: "＋ Add another task",
    missing_224ea: " missing",
    deleteRecord: "Delete {{value}}{{value1}} record",
    noMissingWorkRecordedForThisDate: "No missing work recorded for this date.",
    classEventAdded: "Class event added",
    couldNotSaveTheClassEvent: "Could not save the class event.",
    representative: "Representative | {{subject}}",
    representative_53f0b: "Representative | {{subject}} | 2",
    enterAUniqueNameOfToCharacters: "Enter a unique name of 1 to 40 characters.",
    added: "Added {{value}} '{{name}}'",
    couldNotAddTheItem: "Could not add the item.",
    recordTodaySClassAffairs: "Record today's class affairs",
    event: "Event",
    eGClassMeetingSeatChangesLunch: "e.g. Class meeting, seat changes, lunch reminder",
    addPeopleOrActionsNeedingFollowUp: "Add people or actions needing follow-up",
    addClassEvent: "Add class event",
    classAffairsLog: "Class affairs log",
    noRecordsYet: "No records yet",
    subjectRepresentativesAndClassRoles: "Student roles",
    subjectRepresentatives: "Subject representatives",
    representative_f26c6: "Representative",
    representative_8621e: "{{subject}} representative (1)",
    notAssigned: "Not assigned",
    secondRepresentative: "Second representative",
    representative_a40c4: "{{subject}} representative (2)",
    addCustomSubject: "Add custom subject",
    addRepresentative: "Add representative",
    classDuties: "Class duties",
    otherDuties: "Other roles",
    exportDutiesPdf: "Export PDF",
    addCustomClassRole: "Add custom role",
    addRole: "Add role",
    quizCodeCreated: "Quiz code {{code}} created",
    couldNotCreateTheQuizTryAgain: "Could not create the quiz. Try again later.",
    questionBankAndQuizTabs: "Question bank and quiz tabs",
    startQuiz: "Start quiz",
    quizRecords: "Quiz records",
    studentHistory: "Student history",
    chooseQuestionBank: "Choose question bank",
    inProgress: "In progress",
    returnToOpenQuiz: "Return to open quiz",
    submitted_61549: " submitted",
    customQuestionBank: "Custom question bank",
    questions: " questions ·",
    questions_39ec5: " questions",
    noQuestionBanksInThisClassYet: "No question banks in this class yet",
    classQuiz: "Class quiz",
    backToQuestionBank: "← Back to question bank",
    timeAllowed: "Time allowed",
    minutes: "2 minutes",
    minutes_93fd4: "5 minutes",
    minutes_5125d: "8 minutes",
    minutes_15ebc: "10 minutes",
    minutes_fc4d4: "15 minutes",
    openQuizAndGenerateQRCode: "Open quiz and generate QR code",
    productPreviewSimulatedSession: "Product preview · Simulated session",
    studentsScanToBegin: "Students scan to begin",
    classCode: "Class code",
    timePerStudent: "Time per student:",
    minutes_3d6c1: " minutes",
    thisQRCodePreviewsTheLayoutOnly:
      "This QR code previews the layout only. Connect Supabase before students can join and submit.",
    qrCodeToJoinQuiz: "QR code to join quiz {{code}}",
    openStudentPage: "Open student page ↗",
    liveSubmissions: "Live submissions",
    pastQuizRecords: "Past quiz records",
    ended: "Ended",
    noClassroomQuizzesOpenedYet: "No classroom quizzes opened yet.",
    studentQuizHistory: "Student quiz history",
    completedQuizzes: "Completed quizzes",
    averageScore: "Average score",
    latestSubmission: "Latest submission",
    classCreated: "Class created",
    couldNotCreateTheClassTryAgain: "Could not create the class. Try again later.",
    importedStudents: "Imported {{length}} students",
    addedToQuestionBank: "'{{title}}' added to question bank",
    invalidJSONFormat: "Invalid JSON format.",
    questionsGeneratedCheckAnswersAndSourcesBefore: "Questions generated. Check answers and sources before saving.",
    couldNotGenerateQuestions: "Could not generate questions.",
    permanentlyDeletedAndRelatedData: "Permanently deleted {{name}} and related data",
    couldNotDeleteStudentData: "Could not delete student data.",
    administrationScope: "Administration scope",
    classesAndStudents: "Classes and students",
    questionBankManagement: "Question bank management",
    schoolWideCalendar: "School-wide calendar",
    className: "Class name",
    eGBChinese: "e.g. 2B Chinese",
    sharesRosterAndSeatingWith: "Shares roster and seating with '",
    label_36150: "'",
    status: "Status",
    activate: "Activate",
    deactivate: "Deactivate",
    generateQuestionsFromTeachingMaterials: "Generate questions from teaching materials",
    doNotEnterStudentPersonalData: "Do not enter student personal data",
    materialsAreSentToAThirdParty:
      "Materials are sent to a third-party AI provider. Do not paste student names, health information, special educational needs, discipline information or other identifiable data.",
    teachingMaterials: "Teaching materials",
    pasteThePassageOrNotesForQuestions: "Paste the passage or notes for questions",
    numberOfQuestions: "Number of questions",
    generating: "Generating…",
    generateIntoTheEditorBelow: "Generate into the editor below",
    aiQuestionGenerationIsAvailableAfterConnecting:
      "AI question generation is available after connecting production Supabase.",
    reviewAndImportQuestionSet: "Review and import question set",
    questionSetJSON: "Question set JSON",
    nSchemaVersionNTitleClassQuizN: '{\\n  "schemaVersion": 1,\\n  "title": "Class quiz",\\n  "questions": [...]\\n}',
    validateAndAddToQuestionBank: "Validate and add to question bank",
    questionBank: "Question bank",
    manualImport: "Manual import",
    noQuestionSetsYetPasteJSONOn: "No question sets yet. Paste JSON on the left and validate it.",
    closePermanentDeletionDialog: "Close permanent deletion dialog",
    thisCannotBeUndoneTheStudentQuiz:
      "This cannot be undone. The student, quiz answers and grades will be deleted and removed from attendance, missing work, classroom records, seats and roles. Exact name matches in notes become 'Deleted student'.",
    enterStudentName: "Enter student name '",
    toConfirm: "' to confirm",
    deleting: "Deleting…",
    permanentlyDeleteAllRelatedData: "Permanently delete all related data",
    importedSchoolWideEvents: "Imported {{length}} school-wide events",
    couldNotImportTheSchoolWideCalendar: "Could not import the school-wide calendar.",
    couldNotDeleteTheCalendarEvent: "Could not delete the calendar event.",
    deleteThisSchoolWideEventWillDisappear:
      "Delete '{{title}}'? This school-wide event will disappear from every class calendar.",
    schoolWideEventDeleted: "School-wide event deleted",
    deleteTheLatestEventsImportedFrom: "Delete the latest {{length}} events imported from '{{value}}'?",
    latestSchoolWideCalendarImportDeleted: "Latest school-wide calendar import deleted",
    sharedSchoolWideEvents: "Shared school-wide events",
    deleteLatestImport: "Delete latest import",
    importCalendar: "Import calendar",
    schoolCalendarSummary: "School calendar summary",
    schoolWideEvents: "School-wide events",
    importedFiles: "Imported files",
    eventsFromToday: "Events from today",
    importedSchoolCalendar: "Imported school calendar",
    to: "To {{value}}",
    source: "Source: {{sourceName}}",
    delete_f46eb: "Delete {{title}}",
    noSchoolWideCalendarImportedYet: "No school-wide calendar imported yet",
    importFirstCalendar: "Import first calendar",
    rows_2a2b7: "Rows",
    columns_ad3ee: "Columns",
    switchView: "Switch view",
    unseatedStudents: "Unseated students",
    selected_cca56: "Selected:",
    collapse: "Collapse",
    expand: "Expand",
    allStudentsHaveSeats: "All students have seats.",
    no_bce6e: "No. {{number}} {{name}}{{value}}",
    placeHere: "Place here",
    aisleBetweenColumnsAnd: "{{value}} aisle between columns {{value1}} and {{value2}}",
    aisleBetweenRowsAnd: "{{value}} aisle between rows {{value1}} and {{value2}}",
    publicHoliday: "Public holiday",
    schoolHoliday: "School holiday",
    specialSchoolDay: "Special school day",
    specialDate: "Special date",
    schoolExam: "School exam",
    studentActivityDay: "Student activity day",
    reminder: "Reminder",
    schoolCalendar: "School calendar",
    calendarEventUpdated: "Calendar event updated",
    calendarEventAdded: "Calendar event added",
    couldNotSaveTheCalendarEvent: "Could not save the calendar event.",
    calendarEventDeleted: "Calendar event deleted",
    couldNotDeleteTheCalendarEvent_d1188: "Could not delete the calendar event.",
    previousMonth: "Previous month",
    nextMonth: "Next month",
    today: "Today",
    filterCalendarEvents: "Filter calendar events",
    newEvent: "＋ New event",
    calendarColourLegend: "Calendar colour legend",
    addEvent: "{{date}}{{value}}. Add event",
    editEvent: "Edit event",
    newEvent_4b257: "New event",
    saveEvent: "Save event",
    view: "View {{value}}: {{title}}{{value2}}",
    notes: "Notes:",
    to_1fe2b: " to {{value}}",
    schoolWide_0628a: "School-wide",
    noAdditionalNotes: "No additional notes.",
    source_dd8a9: "Source:",
    edit: "Edit",
    type: "Type",
    bringInAIGeneratedQuestions: "Bring in AI-generated questions",
    pasteJSONContainingTitleQuestionsFourOptions:
      "Paste JSON containing title, questions, four options, correctIndex and explanation. Each question is validated before saving.",
    classQuestionBank: "Class question bank",
    startMinuteQuiz: "Start 10-minute quiz",
    studentQuizCode: "Student quiz code",
    submitted_61215: "Submitted",
    responses: " responses",
    previewDataJson: "{{value}}-preview-data.json",
    fullExportJson: "{{value}}-{{value1}}-full-export.json",
    dataFileDownloadStarted: "Data file download started",
    exportFailed: "Export failed: {{message}}",
    exportFailedTryAgain: "Export failed. Try again.",
    previewModeDoesNotCreateOrDelete: "Preview mode does not create or delete cloud data",
    theWorkspaceBecomesReadOnlyImmediatelyAnd:
      "The workspace becomes read-only immediately and is deleted after 30 days. Continue?",
    readOnlyDataRetainedUntil: "Read-only. Data retained until {{value}}",
    demoData: "Demo data",
    trial: "Trial",
    dayFullTrial: "7-day full trial",
    allNonAIFeaturesAreAvailable: "All non-AI features are available.",
    aboutDaysLeftNonAIFeaturesAre: "About {{trialDays}} days left. Non-AI features are unrestricted during the trial.",
    teacherAccount: "Teacher account",
    previewAccount: "Preview account",
    dataSpace: "Data space",
    retainedAfterCancellation: "Retained after cancellation",
    daysReadOnly: " days read-only",
    thePaymentPageOpensAfterStripeIs: "The payment page opens after Stripe is connected",
    managePaymentsAndSubscription: "Manage payments and subscription",
    chooseMonthlyPlan: "Choose monthly plan",
    youControlYourData: "You control your data",
    fullDataExport: "Full data export",
    exportNow: "Export now",
    deleteWorkspace: "Delete workspace",
    readOnlyImmediatelyRetainedForExportFor:
      "Read-only immediately; retained for export for 30 days by default, then permanently deleted.",
    requestDeletion: "Request deletion",
  },
};
